import Reflux from 'reflux'
import axios from 'axios'
import _ from 'lodash'

import IngredientsTypesActions from '~/actions/ingredientsTypes.js'

import apiUtils from '../helper/api.js'


export default class extends Reflux.Store {
	constructor() {
		super()

		this.listenables = IngredientsTypesActions

		this.state = {
			ingredientsTypes: [],
			showIngredientsTypesTypesModal: false
		}

		// hydrate as soon as initialized
		this.reload()
	}

	reload() {
		axios.get(`${apiUtils.getApiURL()}/ingredientTypes?filter[where][isActive]=1`)
			.then(
				(response) => {
					let ingredientsTypes = response.data

					ingredientsTypes = _.forEach(
						ingredientsTypes,
						(theIngredient) => {
							const newIngredient = theIngredient

							newIngredient.capitalized = theIngredient.ingredientType.toUpperCase()

							return newIngredient
						}
					)

					this.setState({ ingredientsTypes: _.sortBy(ingredientsTypes, 'capitalized') })
				}
			)
	}

	showModal() {
		this.setState({ showIngredientsTypesTypesModal: true })
	}

	hideModal() {
		this.setState({ showIngredientsTypesTypesModal: false })
	}
}



// WEBPACK FOOTER //
// ./src/stores/ingredientsTypes.js